import { useEffect, useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { BLOCK_DEFINITIONS } from './blockTypes';
import BlockEditor from './BlockEditor';

export default function BlockCard({ block, index, total, onUpdate, onRemove, onMove, onToggleVisibility, expandedBlockId, scrollToBottomOnExpand = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const [draftContent, setDraftContent] = useState(block.content || {});
  const [isDirty, setIsDirty] = useState(false);
  const def = BLOCK_DEFINITIONS.find((d) => d.type === block.type);

  useEffect(() => {
    setDraftContent(block.content || {});
    setIsDirty(false);
  }, [block.content, block.id]);

  useEffect(() => {
    if (expandedBlockId && expandedBlockId === block.id) {
      setIsOpen(true);
    }
  }, [expandedBlockId, block.id]);

  const isVisible = block.isVisible !== false;

  const handleDraftUpdate = (blockId, content) => {
    if (blockId !== block.id) return;
    setDraftContent(content);
    setIsDirty(true);
  };

  const handleSave = () => {
    onUpdate(block.id, { content: draftContent });
    setIsDirty(false);
  };

  return (
    <div className="pagebuilder-block-card">
      <div className="pagebuilder-block-header">
        <button
          type="button"
          className="pagebuilder-block-header-toggle"
          onClick={() => setIsOpen((v) => !v)}
          aria-expanded={isOpen}
        >
          <i className={`${def?.icon ?? 'bi bi-square'} pagebuilder-block-type-icon`} aria-hidden="true" />
          <span className="pagebuilder-block-label">{def?.label ?? block.type}</span>
          {!isVisible && <span className="pagebuilder-block-count">Hidden</span>}
          <i className={`bi ${isOpen ? 'bi-chevron-up' : 'bi-chevron-down'} pagebuilder-block-chevron`} aria-hidden="true" />
        </button>

        <div className="pagebuilder-block-actions">
          <button
            type="button"
            className="pagebuilder-block-action-btn"
            onClick={() => onToggleVisibility(block.id, !isVisible)}
            title={isVisible ? 'Hide block in viewer' : 'Show block in viewer'}
            aria-label={isVisible ? 'Hide block in viewer' : 'Show block in viewer'}
          >
            <i className={`bi ${isVisible ? 'bi-eye' : 'bi-eye-slash'}`} aria-hidden="true" />
          </button>
          <button
            type="button"
            className="pagebuilder-block-action-btn"
            onClick={() => onMove(block.id, -1)}
            disabled={index === 0}
            title="Move up"
            aria-label="Move block up"
          >
            <i className="bi bi-arrow-up" aria-hidden="true" />
          </button>
          <button
            type="button"
            className="pagebuilder-block-action-btn"
            onClick={() => onMove(block.id, 1)}
            disabled={index === total - 1}
            title="Move down"
            aria-label="Move block down"
          >
            <i className="bi bi-arrow-down" aria-hidden="true" />
          </button>
          <button
            type="button"
            className="pagebuilder-block-action-btn pagebuilder-block-action-btn--danger"
            onClick={() => onRemove(block.id)}
            title="Remove block"
            aria-label="Remove block"
          >
            <i className="bi bi-trash" aria-hidden="true" />
          </button>
        </div>
      </div>

      <Collapse
        in={isOpen}
        onEntered={(element) => {
          if (scrollToBottomOnExpand) element.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }}
      >
        <div>
          <div className="pagebuilder-block-body">
            <BlockEditor block={{ ...block, content: draftContent }} onUpdate={handleDraftUpdate} />
            <div className="pagebuilder-field-row mt-3">
              <button
                type="button"
                className="pagebuilder-add-btn pagebuilder-add-btn--sm"
                onClick={handleSave}
                disabled={!isDirty}
              >
                Save Block Changes
              </button>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
}
